import { Component, input, output } from '@angular/core';

import { TabItem } from '../../../types/user-profile.types';

@Component({
  standalone: true,
  imports: [],
  selector: 'sb-tabs-navigation',
  template: `
    <div class="border-b border-t border-gray-200">
      <nav
        class="-mb-px flex space-x-2 sm:space-x-4 lg:space-x-8 px-2 sm:px-4 lg:px-6 overflow-x-auto scrollbar-hide"
        aria-label="Tabs"
      >
        @for (tab of tabs(); track tab.id) {
        <button
          (click)="onTabClick(tab.id, $event)"
          [class]="getTabClasses(tab.id)"
          class="flex-shrink-0 whitespace-nowrap py-3  px-1 sm:px-3 border-b-2 font-medium text-xs sm:text-sm focus:outline-none transition-colors duration-200"
        >
          <span>{{ tab.label }}</span>
        </button>
        }
      </nav>
    </div>
  `,
  styles: [
    `
      /* Custom scrollbar styles for webkit browsers */
      .scrollbar-hide {
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollbar-hide::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
      }

      /* Custom breakpoint for extra small screens */
      @media (min-width: 480px) {
        .xs\\:inline {
          display: inline;
        }
        .xs\\:hidden {
          display: none;
        }
      }
    `,
  ],
})
export class TabsNavigationComponent {
  // Inputs
  tabs = input.required<TabItem[]>();
  activeTab = input.required<string>();

  // Outputs
  tabChanged = output<string>();

  onTabClick(tabId: string, event: Event) {
    event.preventDefault();
    this.tabChanged.emit(tabId);
  }

  getTabClasses(tabId: string): string {
    const isActive = this.activeTab() === tabId;

    if (isActive) {
      return 'border-orange-500 text-orange-600';
    } else {
      return 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300';
    }
  }
}
